import { render, staticRenderFns } from "./form-flat.vue?vue&type=template&id=33f3b6ef&scoped=true"
import script from "./form-flat.vue?vue&type=script&lang=js"
export * from "./form-flat.vue?vue&type=script&lang=js"
import style0 from "./form-flat.vue?vue&type=style&index=0&id=33f3b6ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f3b6ef",
  null
  
)

export default component.exports